export const SCRIPT_CONFIG = {
  GOOGLE_MAPS: {
    id: 'google-maps',
  },
  STONLY: {
    url: 'https://stonly.com/js/widget/v2/stonly-widget.js',
    id: 'stonly-widget',
    widgetId: '4d748f19-7cc7-11ed-871a-0a52ff1ec764',
  },
  PYLON: {
    url: 'https://widget.usepylon.com/widget/3ae2d970-2dbb-43f2-b6c6-dab95aaee6df',
    id: 'pylon-widget',
  },
  QUARTERZIP: {
    url: 'https://app.quarterzip.ai/sdk/qz.js',
    id: 'quarterzip-sdk-script',
  },
} as const;
